import { OptionDataInterface } from 'modules/product/views/components/product-offers-header/interfaces/option.data.interface';

export const SORT_OPTIONS: OptionDataInterface[] = [
    {
        label: 'Najlepsze oferty',
        value: 'score',
        className: 'gtm_osrt_bst'
    },
    {
        label: 'Najpopularniejsze sklepy',
        value: 'shop-score',
        className: 'gtm_osrt_rnk'
    },
    {
        label: 'Cena od najwyższej',
        value: 'price-desc',
        className: 'gtm_osrt_prc-desc'
    },
    {
        label: 'Cena od najniżeszej',
        value: 'price-asc',
        className: 'gtm_osrt_prc-asc'
    }
];
